import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { EMPTY, Observable } from 'rxjs';
import { MortgageApplicationFormService } from './mortgage-application-form.service';

@Injectable()
export class MortgageApplicationDataResolver implements Resolve<any> {
  constructor(private readonly mortgageAplicationFormService: MortgageApplicationFormService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    if (this.isChildRoute(route)) {
      const applicationId = route.params['applicationId'];

      return this.mortgageAplicationFormService.initialize(applicationId);
    }

    return EMPTY;
  }

  private isChildRoute(route: ActivatedRouteSnapshot): boolean {
    return route.params['applicationId'] !== 'undefined';
  }
}
